import "../style/Contact.css";
import Swal from 'sweetalert2';

const Contact = () => {
  const onSubmit = async (event: { preventDefault: () => void; target: any; }) => {
    event.preventDefault();
    const form = event.target;
    const formData = new FormData(form);

    formData.append("access_key", "d105f095-587d-4036-8597-4eb61f7ca265");

    const object = Object.fromEntries(formData);
    const json = JSON.stringify(object);

    const res = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: json
    }).then((res) => res.json());

    if (res.success) {
      Swal.fire({
        title: "Success!",
        text: "Message Sent Successfully",
        icon: "success"
      });
      form.reset();
    }
  };

  return (
    <div className="forms">

      <form className='contactform' onSubmit={onSubmit}>
        <h1 style={{ textAlign: "center", marginBottom: "10px" }}>Contact</h1>

        <div className='inputs'>
          <input type="text" name='name' placeholder='Enter Your name' required />
        </div>

        <div className='inputs'>
          <input type="email" name='email' placeholder='Enter Your mail' required />
        </div>

        <div className='inputs'>
          <input
            type="text"
            name="contact"
            placeholder="Enter Your Contact"
            pattern="^[0-9]{10}$"
            title="Contact number must be exactly 10 digits and contain only numbers."
            required
          />
        </div>

        <div className='inputs'>
          <input
            type="number"
            name="minBoxesPerMonth"
            placeholder="Minimum Number of Boxes per Month"
            min={1}
            required
          />
        </div>

        <div className='inputs'>
          <textarea placeholder='Message Box' name='message'></textarea>
        </div>

        <button className='but'>Submit</button>
      </form>

    </div>
  )
}

export default Contact;
